import React, { useEffect, useState } from "react";
import TextView from "../../../TextView";
import MediaSelection from "../MediaSelection";
import styled from "styled-components";
import { colors } from "../../../../utils";
import PaletteItem from "./PaletteItem";
import { generateColorsFromImage } from "../../../../services/api";
import { useDispatch, useSelector } from "react-redux";
import { addColorPalettes } from "../../../../redux/reducers/colorPalette";
import { getSelectedSegment } from "../../../../redux/selectors/segmentBuilderSelectors";
import { getRandomId } from "../../../../utils/helpers";
import { getPaletteColors } from "../../../../redux/selectors/colorPalette";
import { CircularProgress } from "@mui/material";
import { PALETTE_TYPES } from "./constants";
import Button from "../../../Button";

const ImageWrapper = styled.div`
  display: grid;
  grid-template-columns: 120px 1fr;
  grid-gap: 20px;
  margin-bottom: 20px;
  align-items: center;
`;

const UploadedImage = styled.img`
  width: 120px;
  height: 120px;
  object-fit: cover;
  border-radius: 8px;
  border: 1px solid ${colors.lightBorder};
`;

export default function Image({ paletteType}) {
  const [image, setImage] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const selectedArc = useSelector(getSelectedSegment);
  const paletteColors = useSelector((state) =>
    getPaletteColors(state, "image", paletteType)
  );
  const dispatch = useDispatch();

  function transformPaletteData(data, imageUrl) {
    return data.map((item, i) => ({
      index: i,
      paletteName: item.palette_name,
      imageUrl,
      colors: item.colors.map((color, ind) => ({
        hex: color,
        id: getRandomId(),
        index: ind,
        locked: paletteType == PALETTE_TYPES.SEGMENT && ind === 0,
      })),
      id: getRandomId(),
      selected: true,
    }));
  }

  useEffect(() => {
    if (image) handleGenerateSchemes();
  }, [image]);

  const handleImageChange = (_, value) => {
    setImage(value?.src);
  };

  const handleGenerateSchemes = async () => {
    const savedImage = image || paletteColors[0]?.imageUrl;
    if (savedImage) {
      setLoading(true);
      setError("");

      try {
        // Call the API to generate colors
        const response = await generateColorsFromImage(
          savedImage,
          paletteType == PALETTE_TYPES.WHEEL ? 20 : 5
        );

        if (response.data.success) {
          const transformedPalettes = transformPaletteData(
            [response.data.data],
            savedImage
          );

          // Dispatch action to update the Redux store
          dispatch(
            addColorPalettes({
              paletteType,
              type: "image",
              imageUrl: savedImage,
              segmentId: selectedArc?.id,
              paletteColors: transformedPalettes,
            })
          );
        } else {
          setError("Failed to generate colors from the image.");
        }
      } catch (err) {
        console.error("Error generating colors:", err);
        setError("An error occurred while generating colors.");
      } finally {
        setLoading(false);
      }
    }
  };

  return (
    <div>
      {image || paletteColors.length ? (
        <ImageWrapper>
          <UploadedImage src={image || paletteColors[0].imageUrl} />
          {loading ? (
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                padding: 10,
                border: `1px solid ${colors.lightBorder}`,
                borderRadius: 8,
              }}
            >
              <CircularProgress size={32} />
            </div>
          ) : (
            paletteColors.length && (
              <div>
                <PaletteItem
                  palette={paletteColors[0]}
                  segmentId={selectedArc?.id}
                  handleGenerateSchemes={handleGenerateSchemes}
                  type="image"
                  index={0}
                  paletteType={paletteType}
                />
              </div>
            )
          )}
        </ImageWrapper>
      ) : (
        <TextView variant="largeText" style={{ marginBottom: 20 }}>
          A suggested color theme for your segment will be generated when you
          select an image below.
        </TextView>
      )}
      <MediaSelection
        handleChange={handleImageChange}
        showRecentDropdown={paletteType == "segment"}
      />
    </div>
  );
}
